import React from 'react';

import styles from '../Fields/Fields.module.css';

type CustomInputProps = {
  isInvalid?: boolean;
  narrowVariant?: boolean;
  geavanceerdZoekenVariant?: boolean;
};

export type InputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> &
  CustomInputProps;

export function Input({
  type = 'text',
  narrowVariant,
  isInvalid,
  geavanceerdZoekenVariant,
  ref,
  ...rest
}: InputProps & { ref?: React.Ref<React.ComponentRef<'input'>> }) {
  return (
    <input
      style={narrowVariant ? { height: '28px' } : { minHeight: '38px' }}
      className={geavanceerdZoekenVariant ? styles.inputFieldGeavanceerdZoeken : styles.inputField}
      type={type}
      aria-invalid={isInvalid ? 'true' : 'false'}
      {...rest}
      ref={ref}
    />
  );
}
